import React, { useState } from "react";
import "../styles/Home.css";
import profilePic from "../assets/lilu-profile.jpg";
import pic1 from "../assets/pic1.jpg";
import pic2 from "../assets/pic2.png";
import pic3 from "../assets/pic3.jpg";
import pic4 from "../assets/pic4.jpg";

const Home = () => {
  const [activeFact, setActiveFact] = useState(null);

  const handleClick = (index) => {
    setActiveFact(activeFact === index ? null : index); // toggle
  };

  const funFacts = [
    "My favorite book is The Little Prince by Antoine de Saint-Exupéry",
    "I'm named after the main character in the movie The Fifth Element",
    "I've learned to play the bass guitar and baritone saxophone ",
    "My favorite artist is Gorillaz and I got to see them live in 2022",
  ];

  const [isSpinning, setIsSpinning] = useState(false);

  const handleProfileClick = () => {
    setIsSpinning(true);
    setTimeout(() => setIsSpinning(false), 1000); // reset after animation
  };

  return (
    <div className="home-container">
      <div className="intro-card">
        <button
          className={`profile-pic-button ${isSpinning ? "spin" : ""}`}
          onClick={handleProfileClick}
          aria-label="Click to spin profile picture"
          type="button"
        >
          <img
            src={profilePic}
            alt="Lilu, smiling at the camera"
            className="profile-pic"
          />
        </button>

        <div className="intro-text">
          <h1>
            Hello! I'm <span className="highlight">Lilu ⋆˚꩜｡</span>
          </h1>
          <p>
            I'm a computer science student with a developing passion for tech,
            creativity, and making the world a little brighter through code. 🖳
          </p>
          <p>
            This is my corner of the internet — feel free to explore my
            projects, learn about me, my journey, and reach out if you’d like to
            connect!
          </p>
          <p className="signature">Thanks for stopping by ✮ツ</p>
        </div>
      </div>

      <section className="gallery-section">
        <h2 className="gallery-title">Fun Facts About Me</h2>
        <div className="gallery-grid">
          {[pic1, pic2, pic3, pic4].map((pic, index) => {
            const isActive = activeFact === index;
            return (
              <button
                key={index}
                type="button"
                className={`gallery-item ${isActive ? "is-active" : ""}`}
                onClick={() => handleClick(index)}
                aria-pressed={isActive}
                aria-label={`Fun fact ${index + 1}: ${
                  isActive ? funFacts[index] : "click to reveal"
                }`}
              >
                <img src={pic} alt="" aria-hidden="true" />
                <div className="caption" aria-live="polite">
                  {isActive ? funFacts[index] : `#fact${index + 1}`}
                </div>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Home;
